import * as React from 'react';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import { resetPassword } from 'aws-amplify/auth';
import './Login.scss';
import giggLogo from '../../../images/gigg-logo.svg';
import { Link, useNavigate } from 'react-router-dom';
import ResetPassword from './ResetPassword';

const ForgotPassword: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const email = decodeURIComponent(params.get('email') as string);
  if (code && email) {
    return <ResetPassword code={code} email={email} />;
  }

  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const onFinish = async (values: { email: string }) => {
    setLoading(true);
    try {
      await resetPassword({
        username: values.email,
      });
      message.success('Verification email sent, please check your email to reset your password.');
      setLoading(false);
      navigate('/login');
    } catch (error) {
      console.error(error);
      message.error('Failed to send verification email. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="flex-container justify-center router-wrapper">
      <div className="login-outer">
        <div className="flex-container justify-center">
          <div className="margin-bottom-md">
            <div className="login-image-container">
              <img className="login-img" src={giggLogo} width="100%" height="auto" alt="Gigg" />
            </div>
            <div className="flex-container justify-center">Reset Password</div>
          </div>
        </div>
        <div className="login-inner">
          <Form layout="vertical" className="login-form" onFinish={onFinish}>
            <Form.Item
              name={'email'}
              rules={[
                {
                  required: true,
                  message: 'Please input your email!',
                },
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },
              ]}
            >
              <Input className="login-input" placeholder="Email" type="email" />
            </Form.Item>
            <div className="flex-container margin-bottom-md">
              <div className="flex-container flex">
                <Button className="login-button" htmlType={'submit'} loading={loading}>
                  <span>Send Email</span>
                </Button>
              </div>
            </div>
          </Form>
          <div className="flex-container">
            <Link to="/login" className="login-link">
              Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
